import React, {useState} from 'react';
import {PaymentElement, useElements, useStripe,} from '@stripe/react-stripe-js';
import MDButton from "../../../components/MDButton";
import {Modal} from "react-bootstrap";

export default function CheckoutForm(props) {
  const stripe = useStripe();
  const elements = useElements();

  const clientSecret = props.clientSecret;
  const customerSuccessPart = '#/cx/checkout/success';

  let _currentLocation = window.location.href;
  if (_currentLocation.indexOf('#') > -1) {
    _currentLocation = _currentLocation.split('#')[0];
  }
  const successUrl = _currentLocation + '#/cx/checkout/success';

  const [errorMessage, setErrorMessage] = useState(null);
  const [checkoutActive, setCheckoutActive] = useState(false);
  const [agreeTerms, setAgreeTerms] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (elements == null) {
      return;
    }

    // Trigger form validation and wallet collection
    const {error: submitError} = await elements.submit();
    if (submitError) {
      // Show error to your customer
      setErrorMessage(submitError.message);
      return;
    }

    setCheckoutActive(true);

    const resp = props?.storeCard ? await stripe.confirmSetup({
        //`Elements` instance that was used to create the Payment Element
        elements,
        clientSecret,
        redirect: "if_required",
        confirmParams: {
          return_url: successUrl,
        },
      }) :
      await stripe.confirmPayment({
        //`Elements` instance that was used to create the Payment Element
        elements,
        clientSecret,
        redirect: "if_required",
        confirmParams: {
          return_url: successUrl,
        },
      })

    if (resp) {
      if (resp?.error) {
        props.handleError(resp);
      } else {
        props.handleSuccess(resp);
      }
      setCheckoutActive(false);
    }
  };

  return (
    <>

      <form onSubmit={handleSubmit}>
        <Modal.Body>
          <PaymentElement/>
          {errorMessage && <div>{errorMessage}</div>}
        </Modal.Body>
        <Modal.Footer>

          <MDButton variant="gradient"
                    disabled={!stripe || !elements || checkoutActive || !agreeTerms}
                    type="submit"
                    color="info">
            {props?.storeCard ? 'Save' : 'Complete Purchase'}
          </MDButton>

          <p><label htmlFor={'agree-terms'}>
            <input type={"checkbox"} className={'form-check-input'} required name={'agree-terms'}
                   onChange={(e) => {
                     setAgreeTerms(e.target.checked);
                   }}
                   value={"agree-card-terms"}/>
            &nbsp;<small>
            By placing an order or storing card for future use,
            you agree to our <a href={'#cx/privacy'} target={"_blank"}>privacy notice</a> and <a
            href={'#cx/terms-of-service'} target={"_blank"}> conditions of use</a>.
          </small></label></p>

        </Modal.Footer>
      </form>
    </>
  );
}

